module.exports = __webpack_public_path__ + "media/images/icons/flags/GI-d78d25a4d6c3a875b0d9ae9476ed35a2.svg";